import { useState, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'wouter'
import { IcpFooter, SiteTabs } from '@/components'
import { BookIcon, ColumnsIcon, SearchIcon, SunIcon, MoonIcon } from '@/components/Icons'
import styles from './layout.module.css'

export function Frame({ children }: { children: ReactNode }) {
  const { t } = useTranslation('console')
  const [location, navigate] = useLocation()
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem('wanxiang-theme') === 'light' ? 'light' : 'dark' } catch { return 'dark' }
  })
  const nav = [['/wanxiang', 'wanxiang.home'], ['/wanxiang/guides', 'wanxiang.guides'], ['/wanxiang/cards', 'wanxiang.cards'], ['/wanxiang/equipment', 'wanxiang.equipment']] as const
  return (
    <div className={styles.page} data-theme={theme}>
      <div className={styles.siteTabsBar}>
        <SiteTabs variant="public" />
      </div>
      <header className={styles.header}>
        <Link className={styles.brand} href="/wanxiang"><span className={styles.brandMark}><ColumnsIcon size={26} /></span>{t('wanxiang.brand')}</Link>
        <nav className={styles.nav} aria-label={t('wanxiang.brand')}>
          {nav.map(([href, label]) => <Link key={href} href={href} aria-current={location === href || (href !== '/wanxiang' && location.startsWith(href)) ? 'page' : undefined}>{t(label)}</Link>)}
        </nav>
        <div className={styles.headerActions}>
          <form className={styles.headerSearch} onSubmit={event => { event.preventDefault(); const query = new FormData(event.currentTarget).get('q'); navigate(`/wanxiang/cards?q=${encodeURIComponent(String(query ?? ''))}`) }}>
            <SearchIcon size={22} /><input name="q" aria-label={t('wanxiang.searchCards')} placeholder={t('wanxiang.searchCards')} />
          </form>
          <button aria-label={t('wanxiang.theme')} onClick={() => { const next = theme === 'dark' ? 'light' : 'dark'; setTheme(next); try { localStorage.setItem('wanxiang-theme', next) } catch { /* Optional preference storage. */ } }}>
            {theme === 'dark' ? <SunIcon size={22} /> : <MoonIcon size={22} />}<span>{t(theme === 'dark' ? 'wanxiang.light' : 'wanxiang.dark')}</span>
          </button>
          <a className={styles.login} href="/login">{t('page.login.title')}</a>
        </div>
      </header>
      <main className={styles.main}>{children}</main>
      <div className={styles.footer}><span><BookIcon size={20} />{t('wanxiang.source')}</span><IcpFooter /></div>
    </div>
  )
}
export function Missing({ href, labelKey }: { href: string; labelKey: string }) {
  const { t } = useTranslation('console')
  return <Frame><div className={styles.empty}><h1>{t('wanxiang.missing')}</h1><Link className={styles.action} href={href}>{t(labelKey)}</Link></div></Frame>
}
export function LoadState({ error, retry }: { error: boolean; retry: () => void }) {
  const { t } = useTranslation('console')
  return <div className={styles.empty} role="status"><p>{t(error ? 'wanxiang.loadError' : 'wanxiang.loading')}</p>{error && <button onClick={retry}>{t('wanxiang.retry')}</button>}</div>
}
